/**
 * Plain sentences instead of error codes — the head teacher should learn what to
 * do, not what went wrong internally.
 *
 * A pure map, so the wording can be checked without rendering anything.
 */
const MESSAGES: Record<string, string> = {
  already_invited: "Diese Adresse gehört bereits zu Ihrer Schule.",
  invalid_email: "Bitte prüfen Sie die E-Mail-Adresse.",
  name_missing: "Bitte geben Sie einen Namen an.",
  school_admin_only: "Nur die Schulleitung kann Lehrkräfte hinzufügen.",
  not_signed_in: "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
  invite_failed: "Die Einladung konnte nicht verschickt werden.",
  invite_timeout:
    "Der E-Mail-Dienst hat nicht geantwortet. Bitte versuchen Sie es in ein paar " +
    "Minuten noch einmal.",
  unexpected:
    "Da ist etwas schiefgegangen, womit niemand gerechnet hat. Bitte melden Sie " +
    "sich bei uns.",
  // Der Code fehlte hier, während die Admin-App ihn längst übersetzte – dieselbe
  // Funktion, zwei Aufrufer, ein Satz nur an einer Stelle. In der Verwaltung kam
  // deshalb „Die Einladung ist fehlgeschlagen“ an: der Satz, der nichts sagt.
  // Kann die App eigentlich nicht auslösen – sie schickt POST. „Eigentlich nicht“
  // ist aber kein Satz, den man einer Schulleitung zeigt, und der Wächter unten
  // nimmt die Ausrede nicht an.
  method_not_allowed:
    "Die Einladung wurde falsch angefragt. Bitte laden Sie die Seite neu.",
  profile_failed:
    "Das Konto entstand, das Profil nicht. Bitte versuchen Sie es noch einmal – " +
    "bleibt es dabei, melden Sie sich bei uns.",
  email_rate_limit:
    "Der E-Mail-Dienst ist gerade am Limit. Bitte versuchen Sie es in etwa einer " +
    "Stunde noch einmal.",
};

/**
 * @param status HTTP-Status der Antwort, falls bekannt. Er steht im Rückfalltext,
 *               damit eine Rückfrage etwas Handfestes hat als „fehlgeschlagen“.
 */
export function inviteErrorText(code: string, status?: number): string {
  const known = MESSAGES[code];
  if (known) return known;

  // Der unbekannte Code steht mit im Text. Ohne ihn bleibt von einem Fehlschlag
  // nur „fehlgeschlagen“, und eine Rückfrage aus einer Schule fängt bei null an –
  // genau das ist gerade passiert, weil `profile_failed` hier fehlte.
  const hinweis = status === undefined ? code : `${code}, HTTP ${status}`;
  return `Die Einladung ist fehlgeschlagen (${hinweis}).`;
}
